import {defineConfig} from '../config'
import { utilsService } from './utils'
const {handleResponse} = utilsService

export const systemService = {
  getDevicesListFromToken
};

const {apiUrl, apiVer} = defineConfig.SYSTEM_SERVICE

function getApiPath(){
  return (apiUrl+apiVer)
}

function getDevicesListFromToken(tokenValue) {

  const url = getApiPath()+"/system/devices";
  const requestOptions = {
    method: "GET",
        headers: {
          "accept": "*/*",
          "authorization": `bearer ${tokenValue}`
        }
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

